import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../../../constants/actionTypes";
import { fileToBase64 } from "../../../../../helpers/Tools";
import { logUI } from "../../../../../api/andyliticsApi";
import * as Tools from "../../../../../helpers/Tools";
import Spinner from '../../../../common/spinner';
import { Typography, Icon, FileAttachment, FileUpload, Grid } from "../../../../ecosystem/";
import { CareGapsButtons, CareGapsError, CareGapsHeading } from '../../components';
import CareGapsConfirmationModal from "../../CareGapsConfirmationModal";
import * as procedureType from "../../../../../constants/textConstants";

class BloodPressureUploadDocuments extends React.Component {
    constructor(props) {
        super(props);
        const { careGapAttachments } = this.props
        let fileNames = careGapAttachments?.map((a) => a.FileName)
        this.state = {
            files: [],
            fileNames: careGapAttachments ? fileNames : null, //to get uploaded filename for displaying
            isFileUploaded: false,
            invalidInput: false,
            value: "",
            inputErrorMsg: "",
            showAsValid: false,
            showAsInvalid: false,
            attachments: careGapAttachments ? careGapAttachments : [],
            isFailedToPost: false,
            disableFileInput: (careGapAttachments?.length > 2) ? true : false
        }
    }

    componentDidMount() {
        const { careGapFlowFormInputs, careGapsSessionId } = this.props;
        logUI("MBHWeb.UI.BloodPressureUploadDocuments.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        if (careGapFlowFormInputs?.attachments?.length > 0) {
            this.setState({ isFileUploaded: true })
        }
    }
    handleClickNext = (linkName) => {
        const { careGapFlowFormInputs, history, updateCareGapFlowFormInputs, careGapsSessionId, getCareGapFileAttachments } = this.props;
        logUI(`MBHWeb.UI.BloodPressureUploadDocuments.Next.Clicked`, new Date(), Tools.getURLPath(), { linkName, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
        //reset error state
        this.setState({ isFailedToPost: false });
        getCareGapFileAttachments(this.state.attachments)
        updateCareGapFlowFormInputs(careGapFlowFormInputs, procedureType.BP);
        history.push('/schedulemyBP/summary');
    }

    handleClickPrev = () => {
        const { careGapFlowFormInputs, history, updateCareGapFlowFormInputs, careGapsSessionId, getCareGapFileAttachments } = this.props;
        logUI(`MBHWeb.UI.BloodPressureUploadDocuments.Previous.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        this.setState({ isFailedToPost: false });
        getCareGapFileAttachments(this.state.attachments)
        updateCareGapFlowFormInputs(careGapFlowFormInputs, procedureType.BP);
        history.push('/schedulemyBP/updatehistory');

    }
    handleDelete = (name, index) => {
        const { careGapsSessionId } = this.props;
        logUI(`MBHWeb.UI.BloodPressureUpdateHistory.Remove.Clicked`, new Date(), Tools.getURLPath(), { fileName: name, index, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
        //delete files based on index
        let { files, fileNames, attachments } = this.state;
        fileNames.splice(index, 1);
        files.splice(index, 1);
        attachments.splice(index, 1);

        if (fileNames.length === 0) {
            this.setState({ fileNames: fileNames, isFileUploaded: false, inputErrorMsg: "", files: files, attachments: attachments, disableFileInput: files.length >= 3 });
        } else {
            this.setState({ fileNames: fileNames, inputErrorMsg: "", files: files, attachments: attachments, disableFileInput: files.length >= 3 });
        }
    }

    onInputChange = (event, fileName, isValid, file, inputErrorMsg) => {

        //if the number of files exceed 3, dont let user to attach another file.
        //And, disable the file input control   
        isValid = isValid && this.state.files.length < 3;

        if (this.state.attachments.length >= 2 && isValid) {
            this.setState({ disableFileInput: true });
        }
        if (isValid && this.state.files.length >= 2) {
            this.setState({ disableFileInput: this.state.files.length >= 2 });
        }


        if (isValid) {
            let theFiles = Array.from(event.target.files) //Converting FileList to files for mapping 
            let theFileNames = theFiles.map((elem) => elem.name);

            if (this.state.fileNames == null) {
                this.setState({ fileNames: [...theFileNames] })
            } else {
                this.setState({ fileNames: [...this.state.fileNames, ...theFileNames] })
            }


            this.setState({
                isFileUploaded: true, files: [...this.state.files, ...theFiles]
            });
            this.setState({ inputErrorMsg: "", showAsInvalid: false });
            if (file) {
                fileToBase64(file).then(base64Data => {
                    this.submitFileInputChange(base64Data, file.name, file.name.split(".").pop(), file.size);
                });
            }
        } else {
            this.setState({ inputErrorMsg: inputErrorMsg, showAsInvalid: true })
        }
    }

    isValidate = (file) => {
        //validation for single upload
        const { value, fileSizeInMb } = this.state;
        const maxFileSize = 4
        if (value) {
            const accept = ".pdf,.jpg,.png";
            const fileExtention = value.split('.').pop().toLowerCase();
            if (accept.split(',').indexOf("." + fileExtention) < 0) {
                this.setState({ inputErrorMsg: `Please select a valid document type: ${accept}`, invalidInput: true });
                return false;
            }
            else if (fileSizeInMb > maxFileSize) {
                this.setState({ inputErrorMsg: `Please upload a file smaller than: ${maxFileSize}MB.`, invalidInput: true });
                return false;
            }
            else {
                this.setState({ inputErrorMsg: "" });
                if (file) {
                    fileToBase64(file).then(base64Data => {
                        this.submitFileInputChange(base64Data, file.name, file.name.split(".").pop(), file.size);
                    });
                }
                return true;
            }
        }
        return false;
    }

    submitFileInputChange = (base64Data, FileName, FileExtension, FileSize) => {
        if (base64Data && FileName && FileExtension) {
            this.setState({
                attachments: [...this.state.attachments, { Base64Data: base64Data, FileExtension, FileName, FileSize }]
            });
        }
    }

    
    render() {
        const { isFileUploaded, isFailedToPost } = this.state;
        const { postCareGapDataPending, careGapAttachments } = this.props;
        const validFileTypes = ".pdf,.jpg,.png"
        const validFileTypesNoSpace = validFileTypes.replace(/ /g, ""); //remove spaces
        // const subHeading = "(Optional) Uploading test results, like a chart or graph, will help make everything as complete and accurate as possible.";
        const nextBtnLabel = isFileUploaded || careGapAttachments ? "Next" : "Skip"; //isFailedToPost ? 'Try again' : isFileUploaded ? "Submit" : "Skip";

        return (
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-container">
                <div className="row">

                    <div className="col-12 maxWidth-content">
                        <CareGapsHeading
                            heading="Upload results"
                            description={
                                <>
                                    Uploading any supporting documentation, such as a visit summary or test results, will help us keep your record
                                    as accurate and complete as possible. (Optional)
                                </>
                            }
                        />
                        <div className="row">
                            <div className="col-lg-8 col-xl-7">
                                {isFailedToPost && !postCareGapDataPending && <CareGapsError />}
                            </div>
                        </div>
                        {postCareGapDataPending && <Spinner />}

                        <div className="row">
                            <div className="col-lg-8 col-xl-7">
                                <FileUpload
                                    accept={validFileTypesNoSpace}
                                    maxFileSize={4} //in MB
                                    onHandleChange={(e, fileName, isValid, file, inputErrorMsg) => this.onInputChange(e, fileName, isValid, file, inputErrorMsg)}
                                    placeholder="Select up to 3 files to upload."
                                    acceptFileText="We can accept PDF, JPG, or PNG files."
                                    maxFileSizeText="Max file size: 4 MB."
                                    disabled={this.state.disableFileInput}
                                    id="file"
                                />
                            </div>

                            <div className="col-lg-8 col-xl-7 upload-doc-list">
                                {this.state.attachments && this.state.attachments.map((elem, index) =>
                                    <FileAttachment
                                        fileName={elem.FileName}
                                        fileSize={elem.FileSize}
                                        onClick={() => this.handleDelete(elem, index)}
                                    />
                                )
                                }
                            </div>
                        </div>
                        <CareGapsButtons
                            prev={{
                                onClick: () => this.handleClickPrev()
                            }}
                            next={{
                                label: nextBtnLabel,
                                onClick: () => this.handleClickNext(nextBtnLabel),
                            }}
                        />
                    </div>
                </div>
                <CareGapsConfirmationModal careGapsType="schedulemyBP" />
            </Grid>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        careGapFlowFormInputs: state.careGap.careGapFlowFormInputs,
        postCareGapDataPending: state.careGap.postCareGapDataPending,
        careGapsSessionId: state.careGap.careGapsSessionId,
        careGapAttachments: state.inMemory.careGapAttachments,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateCareGapFlowFormInputs: (formInputs, procedureType) => dispatch({ type: types.UPDATE_CAREGAP_FLOW_FORM_INPUTS, formInputs, procedureType }),
        getCareGapFileAttachments: (files) => dispatch({ type: types.GET_CAREGAP_FILE_ATTACHMENTS, files }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BloodPressureUploadDocuments);
